<div class="modal-header">
    <h3 class="modal-title">Ajouter une réception de marchandise</h3>
    <button type="button" aria-label="Close" (click)="closeModal()">
        <i class="fa fa-close"></i>
    </button>
</div>
<div class="modal-body">

    <div class="row">
        <div class="col-md-12">
            <div class="row form-group">
                <div class="col-12 col-md-6">
                    <legend for="name" class="">{{'data.reference' | translate}} *</legend>

                    <input type="text" name="idCmd" id="idCmd" class="form-control" #autoInput matInput
                        [matAutocomplete]="auto" (input)="onChange()"
                        [class]="(!isSaved && data.idCmd==null) ? 'input-border-danger' : ''">

                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
                        <mat-option *ngFor="let item of cmds" [value]="item">
                            {{ item?.ref_facture_cmd }}
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="col-12 col-md-6">
                    <legend for="provider" class="">{{'data.provider' | translate}} *</legend>
                    <input name="provider" id="provider" type="text" class="form-control" readonly
                        [value]="provider != null ? (provider?.providerCode + ' - ' + provider?.providerName) : ''">
                </div>

                <div class="col-12 col-md-12" *ngIf="genPallets?.length > 0 || pallets?.length > 0">
                    <div class="row mt-2">
                        <div class="col-12 col-md-4" *ngFor="let item of genPallets">
                            <div class="text-center border p-3 rounded shadow-sm">
                                <!-- Checkbox -->
                                <input type="checkbox" [id]="'pallet_' + item?.palletId"
                                    (change)="toggleSelection(item, $event)">

                                <!-- Infos Pallet -->
                                <div class="mt-2">
                                    <p><strong>Palette #{{ item.palletNumber }}</strong></p>
                                    <p>Nom: {{ item.name }}</p>
                                    <p>Boîtes: {{ item.countBoxes }}</p>
                                    <p>Couches: {{ item.layersNumber }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-4" *ngFor="let item of pallets">
                            <div class="text-center border p-3 rounded shadow-sm">
                                <!-- Checkbox -->
                                <input type="checkbox" [id]="'pallet_' + item?.palletId"
                                    (change)="toggleSelection(item, $event)">

                                <!-- Infos Pallet -->
                                <div class="mt-2">
                                    <p><strong>Palette #{{ item.palletNumber }}</strong></p>
                                    <p>Nom: {{ item.name }}</p>
                                    <p>Boîtes: {{ item.countBoxes }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-12">
                            <h3 class="text-danger" *ngIf="!isSaved && selectedPallets?.length == 0">
                                Merci de selectionner les palettes a recevoir
                            </h3>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="position-relative form-group">
                        <legend for="receptionDate" class="">{{'data.reception_date' | translate}}</legend>
                        <input id="receptionDate" type="date" class="form-control" name="receptionDate" tabindex="1"
                            [(ngModel)]="data.receptionDate"
                            [class]="(!isSaved && data.receptionDate==null) ? 'input-border-danger' : ''">
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <legend for="collectorPickUp" class="">{{'data.enter_collector' | translate}} :</legend>
                    <select class="form-control selectric" [(ngModel)]="data.transportor"
                        [class]="(!isSaved && data.transportor==null) ? 'input-border-danger' : ''">
                        <option [value]="null">{{'data.select_collect' | translate}}</option>
                        <option [value]="collector._id" *ngFor="let collector of collectorList">
                            {{collector.nameSociety}}
                        </option>
                    </select>
                </div>

                <div class="col-12 col-md-12">
                    <legend for="comment" class="">{{'data.notes_comments' | translate}}</legend>
                    <textarea name="comment" id="comment" class="form-control" style="height: 132px;"
                        [(ngModel)]="data.comment"></textarea>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Fermer</button>

    <div *ngIf="isClicked; else elseIsSaved">
        <div class="spinner-container blue-spinner">
            <mat-progress-spinner mode="indeterminate" [diameter]="40" [strokeWidth]="5"></mat-progress-spinner>
        </div>
    </div>
    <ng-template #elseIsSaved>
        <button type="button" class="btn btn-success" (click)="addReceiptCmd()">Valider la réception</button>
    </ng-template>
</div>